import { c as _c } from "react/compiler-runtime";
import SvgCheck from '@common/icon/SvgCheck';
import { cn } from '@core/utils';
import { useSubscribedState } from '@/hooks/useSubscribedState';
import type { HTMLTagProps } from '@/types';
export interface CheckboxProps extends Pick<HTMLTagProps<'div'>, 'className' | 'style'>, Omit<HTMLTagProps<'input'>, 'size' | 'type' | 'style' | 'value' | 'children'> {
  children?: React.ReactNode;
  checkable?: boolean;
}

/**
 * 이거 안 쓰면 이상하게 작동함
 * 다른 페이지에서는 사용하지 말 것
 *
 * @deprecated
 */
export const Checkbox = t0 => {
  const $ = _c(36);
  let checked;
  let children;
  let className;
  let disabled;
  let onChange;
  let ref;
  let restInputProps;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      checkable: t1,
      className,
      style,
      checked,
      onChange,
      disabled,
      ref,
      ...restInputProps
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = children;
    $[3] = className;
    $[4] = disabled;
    $[5] = onChange;
    $[6] = ref;
    $[7] = restInputProps;
    $[8] = style;
    $[9] = t1;
  } else {
    checked = $[1];
    children = $[2];
    className = $[3];
    disabled = $[4];
    onChange = $[5];
    ref = $[6];
    restInputProps = $[7];
    style = $[8];
    t1 = $[9];
  }
  const checkable = t1 === undefined ? true : t1;
  const [turned, setTurned] = useSubscribedState(checked);
  let t2;
  if ($[10] !== className) {
    t2 = cn("flex w-fit items-center gap-8", className);
    $[10] = className;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = turned ? "text-white border-Gray-black bg-Gray-black" : "bg-white border-Gray-500 text-transparent";
  const t4 = disabled && "cursor-not-allowed border-Gray-500 bg-Gray-300 text-Gray-500";
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = cn("flex size-16 min-h-16 min-w-16 cursor-pointer items-center justify-center rounded-xxsmall border-[1.5px] transition-[background-color,border-color] duration-200 ease-in-out", t3, t4);
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== turned) {
    t6 = turned ? <SvgCheck /> : null;
    $[15] = turned;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== checkable || $[21] !== onChange || $[22] !== setTurned) {
    t8 = e => {
      if (checkable) {
        onChange?.(e);
        setTurned(_temp);
      }
    };
    $[20] = checkable;
    $[21] = onChange;
    $[22] = setTurned;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== disabled || $[25] !== ref || $[26] !== restInputProps || $[27] !== t8 || $[28] !== turned) {
    t9 = <input {...restInputProps} ref={ref} readOnly={true} checked={turned} className="hidden" disabled={disabled} type="checkbox" onChange={t8} />;
    $[24] = disabled;
    $[25] = ref;
    $[26] = restInputProps;
    $[27] = t8;
    $[28] = turned;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== children || $[31] !== style || $[32] !== t2 || $[33] !== t7 || $[34] !== t9) {
    t10 = <label className={t2} style={style}>{t7}{t9}{children}</label>;
    $[30] = children;
    $[31] = style;
    $[32] = t2;
    $[33] = t7;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
};
function _temp(prev) {
  return !prev;
}